<div class="unable-to-cancel-container">
  <!-- Coupon Offer View -->
  @if (showCouponOffer()) {
    <div class="coupon-offer-section">
      <div class="icon-container">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gift-icon">
          <polyline points="20 12 20 22 4 22 4 12"></polyline>
          <rect x="2" y="7" width="20" height="5"></rect>
          <line x1="12" y1="22" x2="12" y2="7"></line>
          <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
          <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
        </svg>
      </div>

      <h3 class="offer-title">Wait! Before You Cancel Your Subscription</h3>
      <p class="offer-subtitle">We have a special offer to help you continue enjoying fresh, quality products.</p>

      <div class="coupon-card w-75 mx-auto">
        <span class="coupon-badge">Special Offer</span>
        <h4 class="coupon-name">{{ currentCoupon()!.name }}</h4>
        <p class="coupon-description">This exclusive offer has been selected specifically for you to enhance your experience with us.</p>
      </div>

      <div class="action-buttons">
        <button 
          type="button" 
          class="btn btn-primary btn-lg"
          (click)="onAcceptCoupon()"
          [disabled]="isApplyingCoupon()">
          @if (isApplyingCoupon()) {
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Applying...
          } @else {
            Accept Offer
          }
        </button>
        <button 
          type="button" 
          class="btn btn-outline-secondary btn-lg btn-reject"
          (click)="onRejectCoupon()"
          [disabled]="isApplyingCoupon()">
          No Thanks
        </button>
      </div>

      @if (hasMoreCoupons()) {
        <p class="more-offers-hint">More offers available if you decline</p>
      }
    </div>
  }

  <!-- Final Message View (No Coupons or All Rejected) -->
  @if (showFinalMessage()) {
    <div class="final-message-section">
      <div class="icon-container">
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="info-icon">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
      </div>

      <h3 class="final-title">Subscription Cancellation Information</h3>

      <div class="info-card">
        <div class="info-section">
          <h5 class="info-heading">Membership Requirements</h5>
          <p>Your membership requires you to remain subscribed to at least one FarmBox.</p>
        </div>

        <div class="info-section">
          <h5 class="info-heading">Change Your FarmBox</h5>
          <p>If you'd like to change your FarmBox selection, please complete <a rel="noopener" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLScBa__EF9rGfl88CdlL_I-NSAPtOrsKvLVLi_9AY-TTy6wmuw/viewform" class="form-link">this form</a>, and we will make the necessary adjustments.</p>
          <div class="alert-box">
            <strong>Important:</strong> If you submit your request after 5 PM on Sunday and have an upcoming order that week, we will do our best to accommodate the change, but we cannot guarantee we will have all items in stock.
          </div>
        </div>

        <div class="info-section">
          <h5 class="info-heading">Cancel Your Subscription</h5>
          <p>To cancel your subscription, please contact our support team via <strong>{{ supportEmail }}</strong>.</p>
          <div class="alert-box">
            <strong>Important:</strong> If you submit your cancellation request after 5 PM on Sunday and have an upcoming order that week, you will still be responsible for that order.
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <button 
          type="button" 
          class="btn btn-primary btn-lg"
          (click)="closeModal()">
          I Understand
        </button>
      </div>
    </div>
  }
</div>